import {createSlice} from '@reduxjs/toolkit';

import storageService from '@/services/storage/storageService';

const getInitialState = () => {
    const {accessToken, expirationDate, refreshToken, username, isAnonymous, gigyaToken} =
        storageService.getAuthDataFromStorage() || {};

    return {
        accessToken,
        expirationDate,
        refreshToken,
        gigyaToken,
        username,
        isAnonymous,
    };
};

export const slice = createSlice({
    name: 'auth',
    initialState: getInitialState(),
    reducers: {
        setAuthData: (state, action) => {
            const {accessToken, refreshToken, expirationDate, isAnonymous, gigyaToken} = action.payload;

            return {
                ...state,
                accessToken,
                refreshToken,
                expirationDate,
                gigyaToken,
                isAnonymous,
            };
        },
    },
});

export const {setAuthData} = slice.actions;

export default slice.reducer;
